import React from 'react';
import HeaderNav from 'js/components/header/HeaderNav';
import Footer from 'js/components/footer/Footer';

// import containers
import ContainerBalloonAnimation from '../containers/Conatiner.balloon-animation';

// import tracking
import { track, TRACKING_EVENTS } from 'js/utils/tracking';

const PageHome = ({ toggleModal }) => {
  React.useEffect(() => {
    track(TRACKING_EVENTS.PAGE_DISPLAY.id, {
      page: 'homepage',
      page_title: 'Bluey Movie - Homepage',
    });
  }, []);

  return (
    <>
      <HeaderNav toggleModal={toggleModal} />
      <ContainerBalloonAnimation />
      <Footer />
    </>
  );
};

export default PageHome;
